import { ColorSAP } from "../../ontego-ui";
import { styled } from "@mui/material";

const Styled = {};

Styled.SnackbarWrapper = styled("label")(() => ({
  position: "fixed",
  bottom: 0,
  left: 0,
  right: 0,
  width: "100%",
  height: 88,
  zIndex: 13000,
}));

Styled.SnackbarContainer = styled("label")(({ theme }) => ({
  // [theme.breakpoints.between("1280", "1440")]: {
  //   paddingTop: 4,
  //   paddingLeft: 40,
  //   paddingRight: 40,
  // },
  // [theme.breakpoints.up("1440")]: {
  //   paddingTop: 4,
  //   paddingLeft: 120,
  //   paddingRight: 120,
  // },
}));

Styled.SnackbarIconContainer = styled("label")(() => ({
  "& svg": {
    width: 30,
    height: 30,
    color: ColorSAP.neutral[0],
    marginTop: 6,
  },
}));

Styled.Meter = styled("label")(() => ({
  height: 8,
  overflow: "hidden",
  animation: "$progressKeyframe linear",
  WebkitAnimation: "$progressKeyframe linear",
}));

export default Styled;
